<template>
    <div class="container-fluid py-4">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <div>
                <label class="mb-0 mr-2">
              <input type="checkbox" v-model="todayOnly" @change="fetchOrders" />
              Today only
            </label>
            </div>
        </div>
        <div class="card-deck">
            <div class="card" v-if="kdsItem.order" style="min-width: 18em;" v-for="(kdsItem,index) in filteredOrders" :key="kdsItem.id">
                <div class="card-header" :class="getHeaderClass(kdsItem)">
                    <div class="row">
                        <div class="col-6">
                            <h5 class="text-capitalize">
                                {{ kdsItem?.order?.soldby?.full_name || kdsItem?.order?.soldby?.name }}
                            </h5>
                            <p>{{ kdsItem.order.order }}</p>
                            <p><small>{{ formatDate(kdsItem.created_at) }}</small></p>
                        </div>
                        <div class="col-6">
                            <div class="text-right">
                                <button class="btn btn-sm" :class="getButtonClass(kdsItem)" @click="handleAction(kdsItem,index)" :disabled="kdsItem?.status === 'done'">
        <i :class="getButtonIcon(kdsItem.order)" class="mr-2"></i>
        {{ getButtonLabel(kdsItem) }}
      </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <table class="table">
                        <tbody>
                            <p v-for="(item, index) in kdsItem.order.orders" :key="index">
                                <span>
                <span class="badge badge-secondary py-1">{{ item.qty }}</span> |
                                </span>
                                <span class="text-left">{{ item?.product?.product }}</span>
                            </p>
                        </tbody>
                    </table>
                    <p v-if="kdsItem?.order?.ordernotes.length > 0" class="py-2">{{ kdsItem.order?.ordernotes[0].note }}</p>
                </div>
                <div class="card-footer">
                    <!-- You can show elapsed time or order ID here if needed -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import {
        update
    } from "lodash";
    export default {
        name: "KDSList",
        data() {
            return {
                orders: [],
                previousIds: [],
                newOrderIds: [],
                todayOnly: true,
                sound: new Audio("/storage/Notifsounds/mixkit-positive-notification-951.wav"),
            };
        },
        computed: {
            filteredOrders() {
                if (!this.todayOnly) return this.orders;
                const today = new Date().toISOString().slice(0, 10);
                return this.orders.filter(order =>
                    order.created_at && order.created_at.startsWith(today)
                );
            },
        },
        mounted() {
            this.fetchOrders();
            this.timer = setInterval(this.fetchOrders, 15000); // 15s
        },
        beforeDestroy() {
            clearInterval(this.timer);
        },
        methods: {
            async fetchOrders() {
                try {
                    const res = await axios.get("/api/get-kitchen-orders");
                    const incoming = res.data
                    const incomingIds = incoming.map(o => o.id);
                    const freshIds = incomingIds.filter(id => !this.previousIds.includes(id));
                    if (freshIds.length) {
                        this.newOrderIds.push(...freshIds);
                        this.playSound();
                    }
                    this.orders = incoming;
                    this.previousIds = incomingIds;
                } catch (err) {
                    console.error("Failed to fetch orders:", err);
                }
            },
            async updateStatus(orderId, status, index) {
                try {
                    const response = await axios.post(`/api/kds-update-status/`, {
                        order_id: orderId,
                        status: status
                    });
                    const updatedOrder = response.data;
                    // Update the specific card's data
                    this.$set(this.orders, index, updatedOrder);
                    // Remove from newOrderIds if needed
                    this.newOrderIds = this.newOrderIds.filter(id => id !== orderId);
                } catch (e) {
                    this.$toasts.push({
                        type: "error",
                        message: `There was an error updating order: ${e}`
                    });
                }
            },
            playSound() {
                this.sound.play().catch(() => {});
            },
            removeFromNew(id) {
                this.newOrderIds = this.newOrderIds.filter(i => i !== id);
            },
            formatAmount(amount) {
                return Number(amount).toLocaleString("en-KE", {
                    style: "decimal",
                    maximumFractionDigits: 0
                });
            },
            formatDate(datetime) {
                const date = new Date(datetime);
                return date.toLocaleString("en-KE", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit"
                });
            },
            getHeaderClass(kdsOrder) {
                const status = kdsOrder?.status;
                const createdAt = new Date(kdsOrder?.created_at);
                const now = new Date();
                const diffMinutes = (now - createdAt) / 1000 / 60;
                if (status === 'in_progress') {
                    return 'bg-warning text-dark';
                } else if (status === 'done') {
                    return 'bg-success text-dark'; // 🌟 Yellow for completed
                } else if (diffMinutes > 10) {
                    return 'bg-danger text-light'; // ⏰ Late order
                } else {
                    return 'bg-dark text-light'; // default
                }
            },
            getButtonLabel(kdsOrder) {
                const status = kdsOrder?.status;
                if (!status || status === 'pending') return 'Acknowledge';
                if (status === 'in_progress') return 'Mark as Done';
                if (status === 'done') return 'Completed';
                return 'Action';
            },
            getButtonClass(kdsOrder) {
                const status = kdsOrder?.status;
                if (!status || status === 'pending') return 'btn-warning';
                if (status === 'in_progress') return 'btn-info';
                if (status === 'done') return 'btn-light disabled';
                return 'btn-secondary';
            },
            getButtonIcon(kdsOrder) {
                const status = kdsOrder?.status;
                if (!status || status === 'pending') return 'bi bi-check2-all';
                if (status === 'in_progress') return 'bi bi-hourglass-split';
                if (status === 'done') return 'bi bi-check-circle-fill';
                return 'bi bi-question-circle';
            },
            handleAction(kdsOrder, index) {
                const status = kdsOrder?.status;
                if (!status || status === 'pending') {
                    this.updateStatus(kdsOrder.id, 'in_progress', index);
                } else if (status === 'in_progress') {
                    this.updateStatus(kdsOrder.id, 'done', index);
                }
            },
            markInProgress(orderId) {
                // call API or update status to in_progress
                console.log(`Marking order ${orderId} as in_progress`);
                // Example: this.$http.post(`/api/orders/${orderId}/acknowledge`)
            },
            markCompleted(orderId) {
                console.log(`Marking order ${orderId} as done`);
                // Example: this.$http.post(`/api/orders/${orderId}/complete`)
            }
        }
    };
</script>

<style scoped>
    .card-title {
        font-size: 1.1rem;
        font-weight: 600;
    }
    .flash {
        animation: flashBorder 1.2s ease-in-out;
    }
    @keyframes flashBorder {
        0% {
            box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7);
        }
        50% {
            box-shadow: 0 0 20px 10px rgba(40, 167, 69, 0.7);
        }
        100% {
            box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
        }
    }
</style>
